/** Internal Request Generic Service */

const InternalRequestService = {
  /**
   * Generate location options of a given inventory locations instance for the inventory select form
   * @param {array} inventoryLocations - array of inventory locations from an item's inventory
   */
  generateLocationOptions: (inventoryLocations) => inventoryLocations.map((inventory_location) => ({
    value : inventory_location.location_id,
    label : `${inventory_location.location}[${inventory_location.sublocation}]`
  })),

  /**
   * Generate quantity to borrow for an item (it can be either the stored or sellable quantity, depends
   * on which one is lower)
   * @param {number} storedQuantity - inventory's stored quantity
   * @param {number} sellableQuantity - inventory's sellable quantity
   */
  getQuantityToBorrow: (storedQuantity, sellableQuantity) => (
    Math.min(storedQuantity, sellableQuantity)
  ),

  /**
   * TODO: move to internal-request-ops/services
   */
  generatePrintPickingListData: (items) => {
    const header = [
      [
        'SKU',
        'Name',
        'Size',
        // TODO: location
        'Requested Quantity',
        'Quantity in Warehouse',
        'Quantity Available'
      ]
    ]

    const transformedItems = items.map((item) => {
      const { inventory } = item

      return [
        inventory?.inventory_sku,
        inventory?.product?.name,
        inventory?.product_dimension?.size,
        item.quantity,
        // TODO: location
        inventory?.stored_quantity,
        InternalRequestService.getQuantityToBorrow(inventory.stored_quantity, inventory.sellable_quantity)
      ]
    })

    return { header: header, data: transformedItems }
  }
}

export default InternalRequestService